export const showScanningProgressImage = (featuresFlags: Features.Flags) =>
  featuresFlags.kortexInstalled && !featuresFlags.vmInstancesEnabled
